"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.025 5.197a.7.7 0 0 1 .965-.22l5.079 3.194a1.807 1.807 0 0 1 0 3.059l-5.079 3.194a.7.7 0 1 1-.745-1.186l5.078-3.193a.407.407 0 0 0 0-.689l-5.078-3.194a.7.7 0 0 1-.22-.965m-4.304-.24a.7.7 0 0 1 .362.613v8.261a.7.7 0 0 1-1.073.593L3.932 11.23a1.807 1.807 0 0 1 0-3.06L9.01 4.978a.7.7 0 0 1 .711-.02M3.113 14.47a.7.7 0 0 1 .969-.205l4.68 3.043q.434.28.897.479a.7.7 0 0 1-.552 1.286A7.4 7.4 0 0 1 8 18.482l-4.681-3.043a.7.7 0 0 1-.206-.969m17.774 0a.7.7 0 0 1-.205.969L16 18.482q-.533.346-1.107.591a.7.7 0 0 1-.552-1.286q.464-.199.896-.48l4.682-3.042a.7.7 0 0 1 .968.205",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 2.3a.7.7 0 0 1 .7.7v18a.7.7 0 1 1-1.4 0V3a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=VersionCompareIcon24.js.map